import { useQuery } from "@tanstack/react-query";
import { getPublicConnectors } from "./usePublicConnectors";
import { getConnectors } from "./useConnectors";
import { SemanticModel, v2 } from "@pufflig/prompt-studio-types";

const getConnectorResources = async (teamId?: string) => {
  const ownConnectors = await getConnectors(teamId);
  const publicConnectors = await getPublicConnectors();

  const connectorResources: Record<string, v2.ConnectorResource> = [...ownConnectors, ...publicConnectors]
    ?.map(
      (c) =>
        ({
          resourceId: c.resource_id,
          resourceType: "connector" as const,
          createdAt: c.created_at,
          connectorType: c.type,
          name: c.name,
          description: c.description,
          isReady: true,
          isPublic: publicConnectors.some((pc) => pc.resource_id === c.resource_id),
          semantic_model: c.semantic_model as unknown as SemanticModel,
        }) as v2.ConnectorResource,
    )
    .reduce((acc, cur) => {
      return {
        ...acc,
        [cur.resourceId]: cur,
      };
    }, {});

  return connectorResources;
};

export const useConnectorResources = (teamId?: string) => {
  return useQuery({
    queryKey: ["connector_resources", teamId],
    queryFn: () => getConnectorResources(teamId),
    refetchOnWindowFocus: true,
    refetchOnMount: false,
  });
};
